import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'adc-multiple-panels',
  templateUrl: './adc-multiple-panel.component.html',
  styleUrls: ['./adc-multiple-panel.component.scss'],
  standalone: false
})
export class AdcMultiplePanelsComponent implements OnInit, AfterViewInit {
  @Input('data') data: any;
  @Input('type') type: any;
  // type: any;
  @ViewChild('panelGrid') panelGrid: any;

  ngOnInit(): void {
    // this.type = this.data.type;
  }

  ngAfterViewInit(): void {
    // this.setDynamicGrid();
  }

  setDynamicGrid() {
    const gridTemplateColumns = this.data.panelData
      .map((panel: any) => {
        return `repeat(${panel.gridValue || 1}, 1fr)`;
      })
      .join(' ');

    this.panelGrid.nativeElement.style.gridTemplateColumns =
      gridTemplateColumns;
  }

  fullscreen(i: any) {
    this.data.panelData[i].options.fullscreen = true;
    // this.toggleFullscreen.emit(this.data[i].fullscreen);
    // this.guideService.closeGuide.next(false);
    // this.clickPanel(this.data[i].id);
  }

  // calculateTotalColumns(): number {
  //   return this.data.panelData.reduce((total: any, p: any) => total + (p.gridValue || 1), 0);
  // }

  exitFullscreen(i: any) {
    this.data.panelData[i].options.fullscreen = false;
    if (
      this.data.panelData.every((val: any) => val.options.fullscreen == false)
    ) {
      // this.toggleFullscreen.emit(this.data[i].fullscreen);
      // this.guideService.closeGuide.next(true);
    }
  }

  closePanel(i: any) {
    this.data.panelData[i].options.closepanel =
      !this.data.panelData[i].options.closepanel;
    const removedEle = document.getElementById(this.data[i].panelData.panelId);
    removedEle?.remove();
    // this.data.filter((val: any) => {
    //   if(val.id == this.data[i].id){
    //     this.data.splice(i, 1);
    //   }
    // });
    console.log(this.data);
  }

  reload(i: any) {
    this.data.panelData[i].options.loading = true;
    setTimeout(() => {
      this.data.panelData[i].options.loading = false;
    }, 2000);
  }

  search(i: any) {
    this.data.panelData[i].options.search =
      !this.data.panelData[i].options.search;
  }

  reset() {}

  clickPanel(id: any) {
    // console.log(id);
    const fullscreenEle = document.getElementById(id);
    if (fullscreenEle?.classList.contains('full-screen')) {
      // console.log(fullscreenEle);
      fullscreenEle.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }

  //Drag And drop
  public draggedPanelId!: string;

  dragStart(event: DragEvent, panelId: string): void {
    this.draggedPanelId = panelId;
    // this.resizing = false;
    if (event.dataTransfer) {
      event.dataTransfer.setData('text/plain', panelId);
      // event.dataTransfer.effectAllowed = 'move';
      // event.dataTransfer.dropEffect = 'move';
      // const draggedElement = document.getElementById(panelId);
      // if (draggedElement) {
      //   event.dataTransfer.setDragImage(draggedElement, 0, 0);
      // }
    }

    // const draggedElement = event.target as HTMLElement;
    // draggedElement.style.opacity = '1.0';
  }

  dragOver(event: DragEvent): void {
    event.preventDefault();
  }

  drop(event: DragEvent, targetPanelId: string): void {
    // console.log('in drop');
    event.preventDefault();
    const sourcePanelId = this.draggedPanelId;
    const sourcePanelIndex = this.data.panelData.findIndex(
      (panel: any) => panel.panelId === sourcePanelId
    );
    // console.log(sourcePanelIndex);
    const targetPanelIndex = this.data.panelData.findIndex(
      (panel: any) => panel.panelId === targetPanelId
    );
    // console.log(targetPanelIndex);

    if (sourcePanelIndex !== -1 && targetPanelIndex !== -1) {
      // Swap the panels in the data
      const tempPanel = this.data.panelData[sourcePanelIndex];
      this.data.panelData[sourcePanelIndex] =
        this.data.panelData[targetPanelIndex];
      this.data.panelData[targetPanelIndex] = tempPanel;
      this.draggedPanelId = '';
    }
  }
}
